import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/config/vant';
import '@/common/script/flexible';
import '@/common/scss/index.scss';
import routerConfig from './router/config';
import '@/common/script/thinkingData.js' ;
import '@/services/axiosIntercept';
import lottie from 'vue-lottie';
Vue.component('lottie', lottie);
import animated from 'animate.css'
Vue.use(animated)
import { Lazyload } from 'vant';
Vue.use(Lazyload);
// 注册时可以配置额外的选项

Vue.use(Lazyload, {
  lazyComponent: true,
  preLoad: 1.3,
});

Vue.config.productionTip = false;

import mitt from "mitt";
Vue.prototype.$mitt = mitt();
import '@/common/script/qqEmoji';
import { initWebTracing } from '@/config/logging';

/*
 * 适用于获取屏幕宽度等分设置 html 的 font-size 情况，比如 flexible.js 库
**/
// 计算最终 html font-size
function modifiableRootRem() {
  const root = document.documentElement;
  const fontSize = parseFloat(root.style.fontSize);
  const finalFontSize = parseFloat(window.getComputedStyle(root).getPropertyValue('font-size'));
  if (finalFontSize === fontSize) return;
  root.style.fontSize = fontSize + (fontSize - finalFontSize) + 'px'; // 【关键代码：差异补上】
}

if (typeof window.onload === 'function') {
  const oldFun = window.onload;
  window.onload = () => {
    (oldFun as () => void)();
    modifiableRootRem();
  };
} else {
  window.onload = modifiableRootRem;
}

// 调试
if (process.env.VUE_APP_SERVER !== 'prodServer') {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://f.diyiedu.com/debug/vconsole.js";
  document.head.appendChild(script);
}

routerConfig(router);
initWebTracing();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
